import { useEffect } from 'react'

import { isDevMode } from '@sportworld/js-sdk/src/envs/envs'

import { toggleAppSettings } from '@/actions'
import { Keys } from '@/platform/platform'
import useStore from '@/store/useStore'

const handleKeyDown = (event: KeyboardEvent) => {
  const { appSettings } = useStore.getState().common
  switch (event.keyCode) {
    case Keys.COLOR_RED:
    case Keys.KEY_1:
      isDevMode &&
        toggleAppSettings({
          isPerformanceMonitorUsed: !appSettings.isPerformanceMonitorUsed,
        })
      break
    case Keys.COLOR_GREEN:
    case Keys.KEY_2:
      isDevMode &&
        toggleAppSettings({
          isDevToolsUsed: !appSettings.isDevToolsUsed,
        })
      break
    case Keys.COLOR_YELLOW:
    case Keys.KEY_3:
      isDevMode &&
        toggleAppSettings({
          isDisabledBlur: !appSettings.isDisabledBlur,
        })
      break
    case Keys.COLOR_BLUE:
      break
  }
}

export const useTizenKeys = () => {
  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [])
}
